import { apiClient } from "@base/api/client";
import { type UseMutationOptions, useMutation } from "@tanstack/react-query";
import { type ProjectContractorItem, projectContractorItemSchema } from "./projectContractorsSchema";

interface CreateProjectContractorRequest {
  projectId: string;
  name: string;
}

async function createProjectContractor({
  projectId,
  name,
}: CreateProjectContractorRequest): Promise<ProjectContractorItem> {
  const response = await apiClient.post<unknown>(`/project-management/api/projects/${projectId}/contractors`, {
    name,
  });
  return projectContractorItemSchema.parse(response.data);
}

export function useCreateProjectContractorMutation(
  options?: Omit<UseMutationOptions<ProjectContractorItem, Error, CreateProjectContractorRequest>, "mutationFn">,
) {
  return useMutation({
    mutationFn: createProjectContractor,
    ...options,
  });
}
